// extracted by mini-css-extract-plugin
export var orderSummary = "_u9-0";
export var showMoreLessButton = "_u9-1";